import { useState } from "react";

import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import Chart from "../Chart";
import Table from "../Table";

const ViewSwitcher = ({ data }) => {
	const { t } = useTranslation();
	const [currentView, setCurrentView] = useState(1);

	const handleViewChange = (target) => {
		if (target === "tabela") {
			setCurrentView(1);
			return;
		}

		if (target === "wykres") {
			setCurrentView(2);
			return;
		}

		const switchTarget = currentView === 1 ? 2 : 1;

		setCurrentView(switchTarget);
		return;
	};

	return (
		<>
			<Stack
				direction="row"
				spacing={1}
				alignItems="center"
				sx={{ position: "absolute", right: 0, top: 0 }}
			>
				<Typography
					variant="span"
					component="span"
					onClick={() => handleViewChange("tabela")}
					sx={{ cursor: "pointer" }}
				>
					{t("table")}
				</Typography>
				<Switch
					checked={currentView !== 1}
					onChange={() => handleViewChange("")}
				/>
				<Typography
					variant="span"
					component="span"
					onClick={() => handleViewChange("wykres")}
					sx={{ cursor: "pointer" }}
				>
					{t("chart")}
				</Typography>
			</Stack>
			{currentView === 1 ? <Table data={data} /> : <Chart data={data} />}
		</>
	);
};

export default ViewSwitcher;
